import AlertModal from './AlertModal';
import AlertModalHandle from './AlertModalHandle';
import ConfirmationModal from './ConfirmationModal';
import ConfirmationModalHandle from './ConfirmationModalHandle';
import FormModal from './FormModal';
import FormModalHandle from './FormModalHandle';
import IAlertModalConfig from './IAlertModalConfig';
import IConformationModalConfig from './IConfirmationModalConfig';
import IFormModalConfig from './IFormModalConfig';
import IModalConfig from './IModalConfig';
import Modal from './Modal';
import ModalHandle from './ModalHandle';
import ModalStack from './ModalStack';
import ModalUtils from './ModalUtils';

const modalStack = new ModalStack();

export { MODAL_LIVE_REGION_CLASS } from './constants';

export function getActiveModalElement(): HTMLElement | undefined {
  return modalStack.getActiveModal()?.$el[0];
}

export default {
  open: (options: Partial<IModalConfig>) => {
    const modal = new Modal({ ...Modal.defaults, ...options });

    modalStack.registerNewModal(modal);

    modal.open();

    return new ModalHandle(modal);
  },

  confirm: (options: Partial<IConformationModalConfig>) => {
    const modal = new ConfirmationModal(options);

    modalStack.registerNewModal(modal);

    modal.open();

    return new ConfirmationModalHandle(modal);
  },

  alert: (options: Partial<IAlertModalConfig>) => {
    const modal = new AlertModal(options);

    modalStack.registerNewModal(modal);

    modal.open();

    return new AlertModalHandle(modal);
  },

  /**
   * @deprecated Use a regular modal with `FormHandler` instead
   */
  presentForm: (options: Partial<IFormModalConfig>) => {
    const modal = new FormModal(options);

    modalStack.registerNewModal(modal);

    modal.open();

    return new FormModalHandle(modal);
  },

  utils: ModalUtils,
};
